import { SpaceAccountCalendarEventObservable } from "@/store/calendar/space-account-calendar-event/SpaceAccountCalendarEventObservable";
import { syntaxTreeModule } from "@mem-labs/common-editor";
import { UNTITLED_CALENDAR_EVENT_TITLE } from "@/domains/untitled/untitled";

export const createNoteEncodedContentForCalendarEvent = (
  calendarEvent: SpaceAccountCalendarEventObservable
): { encodedContent: string; primaryLabel: string } => {
  const primaryLabel = calendarEvent.primaryLabel || UNTITLED_CALENDAR_EVENT_TITLE;

  const h1 = document.createElement("h1");
  h1.textContent = primaryLabel;
  const html = document.createElement("html");
  html.appendChild(h1);

  const htmlContent = html.outerHTML;
  const encodedContent = syntaxTreeModule.convertHtmlToEncodedContent({ htmlContent });
  return { encodedContent, primaryLabel };
};

export const MIN_ATTENDEE_COUNT = 2;

export const getMeetingPlatformFromUrl = (url: string | null | undefined): string => {
  if (!url) return "Meeting";

  if (/zoom\.us/i.test(url)) {
    return "Zoom";
  }

  if (/meet\.google\.com/i.test(url)) {
    return "Google Meet";
  }

  if (/teams\.(microsoft\.com|live\.com)/i.test(url)) {
    return "Microsoft Teams";
  }

  if (/slack\.com/i.test(url)) {
    return "Slack";
  }

  return "Meeting";
};
